// When the mini player (MiniPlayer.tsx) shows.

import { useLocation } from 'react-router-dom';
import { getChordPlayer } from '@/audio/player';
import { useTransportState } from '@/audio/useSequencePlaying';
import { APP_ROUTES, isWorkbenchRoute, LEGACY_ROUTES } from '@/navigation';

/** Pages that draw a transport of their own. */
export function pageHasTransport(pathname: string): boolean {
  const path = pathname.length > 1 ? pathname.replace(/\/+$/, '') : pathname;
  return (
    isWorkbenchRoute(path) ||
    path === APP_ROUTES.scoreStudio ||
    path === LEGACY_ROUTES.score ||
    path === APP_ROUTES.metronome
  );
}

/** Whether the mini player shows: a tune playing or paused, on a page without a transport. */
export function useMiniPlayerShown(): boolean {
  const transport = useTransportState();
  const { pathname } = useLocation();
  // The standalone metronome plays an empty form, which is no tune.
  return transport !== 'idle' && getChordPlayer().playingTune() && !pageHasTransport(pathname);
}
